import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import UserFilter from 'components/UserFilter';
import IconButton from 'components/IconButton';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import {fetchTenantOptions as sdkFetchTenantOptions} from 'sdk/bookingSets';

import 'components/Filters/styles.css';
import './styles.css';

const buildTenantOptions = data =>
  data.results.map(tenant => ({
    label: tenant.fullName,
    value: tenant.id,
    object: tenant
  }));

interface BookerFilterProps {
  locationRef: string;
  filterBy: (field: string, value: any) => void;
  bookerRef: any;
  classNameForTesting?: string;
}

class BookerFilter extends React.Component<BookerFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  clearTenantOption = () => {
    this.props.filterBy('tenant', null);
  };

  fetchTenantOptions = search => {
    const {locationRef} = this.props;

    return sdkFetchTenantOptions({locationRef, search});
  };

  render() {
    return (
      <div
        className={classNames(
          'FilterSection',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Booker</div>
        </div>
        <div className="FilterSection__content BookerFilter">
          <UserFilter
            userRef={this.props.bookerRef}
            fetchFunction={this.fetchTenantOptions}
            buildOptions={buildTenantOptions}
            clearOption={this.clearTenantOption}
            filterBy={tenantOption =>
              this.props.filterBy('tenant', _.get(tenantOption, 'value'))
            }
          />
        </div>
      </div>
    );
  }
}

export default BookerFilter;
